(function () {
  'use strict';

  // ─────────────────────────────────────────────────────────────────────────
  // Stilaro Camera Fallback  v1.0
  // Propósito : Habilitar la opción de cámara en Android/Redmi cuando
  //             Stilaro inyecta su modal de subida de imagen.
  // Scope     : Solo páginas de producto · Solo Android.
  // Rollback  : Eliminar el bloque if/endif en layout/theme.liquid y
  //             este archivo de assets/ si se desea.
  // ─────────────────────────────────────────────────────────────────────────

  var LOG = '[Stilaro Cam]';

  // 1. Guardia: HTTPS obligatorio para acceso a cámara
  if (window.location.protocol !== 'https:') {
    console.warn(LOG, 'No HTTPS – abortando.');
    return;
  }

  // 2. Detección de plataforma
  var ua        = navigator.userAgent || '';
  var isAndroid = /Android/i.test(ua);
  var isIOS     = /iPhone|iPad|iPod/i.test(ua);

  console.log(LOG, 'Init →', { android: isAndroid, ios: isIOS, ua: ua.slice(0, 80) });

  // iOS muestra "Hacer foto" nativamente — no se necesita intervención.
  if (!isAndroid) {
    console.log(LOG, 'No es Android — sin intervención.');
    return;
  }

  // ── Estrategia A : parchar <input type="file"> ────────────────────────────
  // Si Stilaro inyecta el input directo en el DOM de la página (no iframe),
  // añadir capture="user" hace que Android presente la cámara frontal como
  // opción en el selector de medios del sistema.
  // Cambiar a "environment" para cámara trasera si se prefiere.

  function patchFileInput(el) {
    if (el._scf_patched) return;
    el._scf_patched = true;

    var accept = (el.getAttribute('accept') || '').toLowerCase();
    if (accept && !accept.includes('image')) return; // no es un input de imagen

    el.setAttribute('capture', 'user');
    console.log(LOG, 'A ✓ capture="user" añadido al input:', el);
  }

  // ── Estrategia B : habilitar cámara en iframes de Stilaro ─────────────────
  // Si Stilaro carga su UI en un <iframe> cross-origin, Chrome Android
  // bloquea la cámara a menos que el iframe tenga allow="camera".
  // Parcheamos el atributo justo cuando el iframe aparece en el DOM,
  // antes de que termine de cargar su contenido.

  function patchIframe(el) {
    if (el._scf_iframe_patched) return;

    var src = el.src || el.getAttribute('src') || '';
    // Parchar iframes de Stilaro o iframes recién creados sin src aún
    var isStilaro = !src || /stilaro|vton|probador/i.test(src);
    if (!isStilaro) return;

    el._scf_iframe_patched = true;
    var allow = el.getAttribute('allow') || '';
    if (!allow.includes('camera')) {
      el.setAttribute('allow', allow ? allow + '; camera' : 'camera');
      console.log(LOG, 'B ✓ allow="camera" añadido al iframe:', src || '(sin src aún)');
    }
  }

  // ── Escanear un nodo y sus descendientes ──────────────────────────────────

  function scanNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'INPUT' && node.type === 'file') patchFileInput(node);
    if (node.tagName === 'IFRAME') patchIframe(node);
    if (node.querySelectorAll) {
      node.querySelectorAll('input[type="file"]').forEach(patchFileInput);
      node.querySelectorAll('iframe').forEach(patchIframe);
    }
  }

  // ── MutationObserver: detectar cuando Stilaro inyecte su modal ────────────

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(scanNode);
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree:   true
  });

  // Escaneo inicial por si el widget ya fue renderizado antes de este script
  scanNode(document.body);
  console.log(LOG, 'MutationObserver activo. Esperando modal de Stilaro…');

})();
